import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './PaymentButton.scss';

function PaymentButton({ children, onClick, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        styles.root,
        { 'ui-btn_primary--disabled': disabled },
      )}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

PaymentButton.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

PaymentButton.defaultProps = {
  disabled: false,
};

export default PaymentButton;
